import { CollectionEntity } from "@busy-human/gearbox";
import { z } from "zod";
export var ParentTrainings;
(function (ParentTrainings) {
    ParentTrainings.Schema = z.object({
        date: z.string().datetime().default(new Date().toISOString()),
        countAssigned: z.number().default(0),
        countMax: z.number().default(0),
        name: z.string().default(""),
    });
    ParentTrainings.DAYS_BEFORE_CUTOFF = 1;
    function Default() {
        return ParentTrainings.Schema.parse({});
    }
    ParentTrainings.Default = Default;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults = Default;
    }
    ParentTrainings.CollectionClass = CollectionClass;
    /** @deprecated ParentTrainings is a subcollection under Season */
    ParentTrainings.Collection = null;
})(ParentTrainings || (ParentTrainings = {}));
//# sourceMappingURL=index.js.map